import decode from 'jwt-decode'
import Router from 'vue-router'
import {
  HTTP
} from '@/http'

const ID_TOKEN_KEY = 'id_token'
const USER_KEY = 'user_key'

let router = new Router({
  mode: 'history'
})

export default {
  login(model) {
    console.log(model);
    const request = HTTP.post(`/auth/`, model)
    return request
      .then(response => {
        this.setUser(response.data.user)
        this.setIdToken(response.data.token)
        return request
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },

  logout() {
    this.clearUser()
    router.go('/')
  },

  isLoggedIn() {
    const user = this.getUser()
    return !!user
  },

  getIdToken() {
    return localStorage.getItem(ID_TOKEN_KEY)
  },

  getUser() {
    var user = JSON.parse(localStorage.getItem(USER_KEY))
    return user
  },

  setUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  },

  clearIdToken() {
    localStorage.removeItem(ID_TOKEN_KEY)
  },

  clearUser() {
    localStorage.removeItem(USER_KEY)
  },

  getParameterByName(name) {
    let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash)
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
  },

  setIdToken(idToken) {
    localStorage.setItem(ID_TOKEN_KEY, idToken)
  },



  getTokenExpirationDate(encodedToken) {
    const token = decode(encodedToken)
    if (!token.exp) {
      return null;
    }

    const date = new Date(0)
    date.setUTCSeconds(token.exp)

    return date
  },

  isTokenExpired(token) {
    const expirationDate = this.getTokenExpirationDate(token)
    return expirationDate < new Date()
  },

  retrievePassword(username) {
    const request = HTTP.post(`/auth/password?username=` + username)
    return request
      .then(response => {
        return request
      })
      .catch(error => {
        return Promise.reject(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js